import { DtoProjectType } from '../../vendor/src/shared/constants';

/** A native file may retain a null project type; the mounted editor still needs a concrete mode. */
export function initializeWorkbenchProjectType(
  storedType: DtoProjectType | null | undefined,
  setProjectType: (type: DtoProjectType) => void,
): DtoProjectType {
  const effectiveType = storedType ?? DtoProjectType.commerce;
  setProjectType(effectiveType);
  return effectiveType;
}
